@if (info()?.report) {
  <div class="connectivity-grid">
    <dl class="description-list connectivity-details">
      <dt class="text-muted">Test ID</dt>
      <dd>{{ info().report.testId }}</dd>

      <dt class="text-muted">Created at</dt>
      <dd>{{ formatDate(info().report.testCreatedAt) }}</dd>

      <dt class="text-muted">Test TTL</dt>
      <dd>{{ formatDate(testTtlToDate()) }} ({{ info().report.testTtl }}s)</dd>

      @if (info().isAdmin) {
        <dt class="text-muted">Last disabled</dt>
        <dd>
          @if (loading()) {
            <span class="icon-wait far fs-5 spin"></span>
          } @else {
            {{ phoneInfo()?.mtDisabledAt ? formatDate(phoneInfo().mtDisabledAt) : '-' }}
          }
        </dd>

        <dt class="text-muted">Issue</dt>
        <dd>{{ reportIssueLabel() }}</dd>

        <dt class="text-muted">Description</dt>
        <dd>{{ info().report.description || '-' }}</dd>
      }
    </dl>
  </div>
}

@if (!missingPings().length && !irregularPings().length && !degradedSignalRanges().length && info()?.connectivityInfo) {
  @if (isCollectingConnectivity()) {
    <p class="text-muted mb-0 mt-10">Collecting connectivity data...</p>
  } @else {
    <p class="text-muted mb-0 mt-10">No connectivity issues found</p>
  }
}

@if (missingPings().length || irregularPings().length || degradedSignalRanges().length) {
  <!-- Ping issues -->
  <div class="ping-issues">
    @if (missingPings().length || irregularPings().length) {
      <div class="ping-issue-group">
        <div class="ping-issue-label">
          <span class="icon-attention text-warning-w2"></span>
          <span class="fw-semibold">Missing pings</span>
        </div>
        <div class="ping-issue-entries">
          @if (irregularPings().length) {
            @for (ping of irregularPings(); track ping.timestampCurrent) {
              <div class="ping-entry" [title]="ping.details">
                <span class="text-muted">{{ formatDate(ping.timestampPrev) }}</span>
                <span class="text-muted mx-0_5">&rarr;</span>
                <span class="text-muted">{{ formatDate(ping.timestampCurrent) }}</span>
                <span class="text-error-r3 ms-0_5">({{ getIrregularPingGap(ping) }} gap)</span>
              </div>
            }
          } @else if (missingPings().length) {
            <div class="ping-entry">
              <span class="text-error-r3">No pings within test interval</span>
            </div>
          }
        </div>
      </div>
    }

    @if (degradedSignalRanges().length) {
      <div class="ping-issue-group mt-10">
        <div class="ping-issue-label">
          <span class="icon-attention text-accent-a2"></span>
          <span class="fw-semibold">Degraded signal</span>
        </div>
        <div class="ping-issue-entries">
          @for (range of degradedSignalRanges(); track range.start) {
            <div class="ping-entry">
              @if (range.start.getTime() === range.end.getTime()) {
                <span class="text-muted">{{ formatDate(range.start) }}</span>
                <span class="text-accent-a2 ms-0_5">({{ range.status }})</span>
              } @else {
                <span class="text-muted">{{ formatDate(range.start) }}</span>
                <span class="text-muted mx-0_5">&rarr;</span>
                <span class="text-muted">{{ formatDate(range.end) }}</span>
                <span class="text-accent-a2 ms-0_5">({{ getDegradedRangeDuration(range.start, range.end) }} {{ range.status }})</span>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="info-toggle mt-10">
      <a class="info-toggle-link" (click)="pingInfoExpanded = !pingInfoExpanded">
        <span class="icon-help-1 text-primary-p8"></span>
        <span>{{ pingInfoExpanded ? 'Hide' : 'About ping monitoring' }}</span>
      </a>

      @if (pingInfoExpanded) {
        <p class="info-toggle-content text-muted mt-0_5 mb-0">
          TelQ devices send a heartbeat signal ("ping") every two minutes to confirm they're online and reachable.<br>
          Missing pings mean the device was unreachable — test results from that period may be unreliable.<br>
          Degraded signal pings indicate poor connectivity, which can also affect delivery accuracy.
        </p>
      }
    </div>
  </div>
}
